export default __webpack_public_path__ + "media/wallpaper/five-full-e0fcebae.jpg";